import { Box, Container, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import Footer from "./footer";

export const About = (props) => {
  return (
    <div style={{backgroundColor:"#03203f"}}>
      <div
        id="portfolio"
        className="text-center"
        style={{ marginTop: -70, marginBottom: -150 }}
        >
        <div className="container">
          <div className="section-title">
            <h2>
              About <span style={{ color: "#009bd6" }}>Us</span>{" "}
            </h2>
          </div>
        </div>
      </div>


      <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,} }}>
          <Grid container spacing={4}>
            <Grid item md={8} xs={12}>
              <Box sx={{ padding: {xs: 1, sm: 2,  md: 3,}, mt: 6}}>
                <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                  Elite <span style={{ color: "#009bd6" }}> Engineering</span>{" "}
                  Work
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography sx={{ fontSize: "16px", color:"white" }}>
                  Founded with a vision to revolutionize the engineering
                  industry, Elite Engineering Company has grown into a trusted
                  name synonymous with quality and innovation. Our journey is
                  marked by a relentless pursuit of excellence, a commitment to
                  client satisfaction, and a passion for engineering.
                </Typography>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src="https://5.imimg.com/data5/SELLER/Default/2023/1/XV/NB/AG/2132833/light-duty-fabrication-work.jpg"
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
       
       

        {/* History */}

        <Box sx={{ py: 2,bgcolor:"#d9d9d9" , padding: {xs: 4, sm: 4,  md: 4,}}}>
          <Box sx={{marginLeft:"1rem"}} >
            <Typography variant="h2" sx={{ fontWeight: "bold" , display:{md:"none" , sm:"block" , xs:"block"}}}>
                <span style={{ color: "#03203f" }}> our</span> <span style={{ color: "#009bd6" }}> History</span>{" "}
                </Typography>
            <Divider sx={{display:{md:"none" , sm:"block" , xs:"block"}}} />
          </Box>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee2"
                  src="https://interestingengineering.com/_next/image?url=https%3A%2F%2Fimages.interestingengineering.com%2Fimages%2Fengineersincreasinglyimportant.jpg&w=1200&q=75"
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{mt:{xs: 5, sm:5,  md: 6,}, padding: {xs: 1, sm: 2,  md: 3,} }}>
                <Typography variant="h2" sx={{ fontWeight: "bold" , display:{sm:"none" , md:"block" , xs:"none"}}}>
                <span style={{ color: "#03203f" }}> our</span> <span style={{ color: "#009bd6" }}> History</span>{" "}
                </Typography>
                <Divider sx={{ mb: 2 ,display:{sm:"none" , md:"block" , xs:"none"}}} />
                <Typography sx={{ fontSize: "16px" ,color:"#03203f"}}>
                  Since our inception, we have been at the forefront of
                  engineering innovation. Our projects have ranged from
                  small-scale local developments to large, complex international
                  ventures. Each project is a testament to our ability to
                  deliver exceptional results, no matter the challenge.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* Mission */}
        <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,} }}>
          <Grid container spacing={4}>
            <Grid item md={8} xs={12}>
              <Box sx={{ mt: 6, padding: {xs: 1, sm: 2,  md: 3,} }}>
                <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                  Our <span style={{ color: "#009bd6" }}> Mission</span>{" "}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography sx={{ fontSize: "15px" ,color:"white" }}>
                  Our mission is to deliver superior engineering solutions that
                  drive progress and innovation. We aim to achieve this through:
                </Typography>
                <Typography sx={{ fontSize: "16px"  ,color:"white"}}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Innovation :{" "}
                  </span>{" "}
                  Constantly seeking new and better ways to solve engineering
                  challenges.
                </Typography>

                <Typography sx={{ fontSize: "16px"  ,color:"white"}}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Quality :{" "}
                  </span>{" "}
                  Upholding the highest standards in everything we do.
                </Typography>
                <Typography sx={{ fontSize: "16px"  ,color:"white"}}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Customer Focus :{" "}
                  </span>{" "}
                  Building strong, long-term relationships with our clients by
                  understanding and meeting their needs.
                </Typography>
              </Box>
            </Grid>

            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src="https://www.monolitgrup.com/en/images/articles/large/construction1.jpg"
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* vision */}
        <Box sx={{ py: 2,bgcolor:"#d9d9d9" , padding: {xs: 4, sm: 4,  md: 4,}}}>
          <Box sx={{marginLeft:"1rem"}} >
            <Typography variant="h2" sx={{ fontWeight: "bold" , display:{md:"none" , sm:"block" , xs:"block"}}}>
                <span style={{ color: "#03203f" }}> our</span> <span style={{ color: "#009bd6" }}> Vision</span>{" "}
                </Typography>
            <Divider sx={{display:{md:"none" , sm:"block" , xs:"block"}}} />
          </Box>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee2"
                  src="https://media.licdn.com/dms/image/D4E12AQE89zIm_bgWUg/article-cover_image-shrink_720_1280/0/1685909401418?e=2147483647&v=beta&t=HwfZehDHEQWP1hccSnRPMhAXXfF_ORMOREYdg_fO22o"
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{ mt:{xs: 5, sm:5,  md: 6,}, padding: {xs: 1, sm: 2,  md: 3,} }}>
                <Typography variant="h2" sx={{ fontWeight: "bold" , display:{sm:"none" , md:"block" , xs:"none"}}}>
                <span style={{ color: "#03203f" }}> our</span> <span style={{ color: "#009bd6" }}> Vision</span>{" "}
                </Typography>
                <Divider sx={{ mb: 2 , display:{sm:"none" , md:"block" , xs:"none"}}} />
                <Typography sx={{ fontSize: "16px",color:"#03203f" }}>
                  To be a global leader in the engineering industry, recognized
                  for our expertise, innovation, and customer-centric approach.
                  We envision a future where our solutions contribute
                  significantly to the advancement of society.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* core value  */}
        <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,} }}>
          <Grid container spacing={4}>
            <Grid item md={8} xs={12}>
              <Box sx={{ mt: 6, padding: {xs: 1, sm: 2,  md: 3,} }}>
                <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                  Our <span style={{ color: "#009bd6" }}> Core Values</span>{" "}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography sx={{ fontSize: "16px",color:"white" }}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Integrity :{" "}
                  </span>{" "}
                   We conduct our business with the highest ethical standards.
                </Typography>
                <Typography sx={{ fontSize: "16px" ,color:"white"}}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Excellence :{" "}
                  </span>{" "}
                  We strive for excellence in every project we undertake.
                </Typography>
                <Typography sx={{ fontSize: "16px",color:"white" }}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Collaboration :{" "}
                  </span>{" "}
                  We believe in the power of teamwork and strong partnerships.
                </Typography>
                <Typography sx={{ fontSize: "16px",color:"white" }}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Innovation :{" "}
                  </span>{" "}
                  We embrace new ideas and technologies to stay ahead in the
                  industry.
                </Typography>{" "}
                <Typography sx={{ fontSize: "16px" ,color:"white"}}>
                  <span style={{ color: "#009bd6", fontWeight: "bold" }}>
                    {" "}
                    Sustainability :{" "}
                  </span>{" "}
                  We are committed to sustainable practices that protect our
                  environment.
                </Typography>
              </Box>
            </Grid>

            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                  <img
                    className="imagee"
                    src="https://careeralley.com/wp-content/uploads/engineering.jpg.webp"
                    alt="mission&vision"
                  />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* Certifications */}
        <Box sx={{ py: 2,bgcolor:"#d9d9d9" , padding: {xs: 4, sm: 4,  md: 4,}}}>
          <Box sx={{marginLeft:"1rem"}} >
            <Typography variant="h2" sx={{ fontWeight: "bold" , display:{md:"none" , sm:"block" , xs:"block"}}}>
                <span style={{ color: "#03203f" }}> Certifications and</span> <span style={{ color: "#009bd6" }}> Accreditations</span>{" "}
                </Typography>
            <Divider sx={{display:{md:"none" , sm:"block" , xs:"block"}}} />
          </Box>
          <Grid container spacing={4}>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee2"
                  src="https://www.collegechalo.com/news/wp-content/uploads/2024/02/Instrumentation-and-Control-Engineering.webp"
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
            <Grid item md={8} xs={12}>
              <Box sx={{mt:{xs: 5, sm:5,  md: 6,} ,padding: {xs: 1, sm: 2,  md: 3,} }}>
                <Typography variant="h2" sx={{ fontWeight: "bold", display:{sm:"none" , md:"block" , xs:"none"} }}>
                <span style={{ color: "#03203f" }}> Certifications and</span>{" "}
                  <span style={{ color: "#009bd6" }}> Accreditations</span>{" "}
                </Typography>
                <Divider sx={{ mb: 2 , display:{sm:"none" , md:"block" , xs:"none"}}} />
                <Typography sx={{ fontSize: "16px",color:"#03203f" }}>
                  We are proud to hold numerous certifications and
                  accreditations that attest to our commitment to quality and
                  excellence. These include ISO certifications, industry awards,
                  and memberships in professional organizations.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Community */}

        <Box sx={{ py: 2, padding: {xs: 4, sm: 4,  md: 4,} }}>
          <Grid container spacing={4}>
            <Grid item md={8} xs={12}>
              <Box sx={{ padding: {xs: 1, sm: 2,  md: 3,}, mt: 6}}>
                <Typography variant="h2" sx={{ fontWeight: "bold" }}>
                  Community <span style={{ color: "#009bd6" }}>Engagement</span>{" "}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Typography sx={{ fontSize: "16px" ,color:"white"}}>
                  We believe in giving back to the communities we serve. Our
                  community engagement initiatives include educational programs,
                  charitable contributions, and volunteer work, aimed at making
                  a positive impact.
                </Typography>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={{ mt: 3 }}>
                <div className="imagee-div">
                <img
                  className="imagee"
                  src="https://img.freepik.com/premium-photo/male-engineer-works-desktop-computer-female-chief-engineer-project-manager-finish-project-smile-as-they-laugh-celebrate_76964-200868.jpg?size=626&ext=jpg&ga=GA1.1.1826414947.1722038400&semt=ais_user"
                  alt="mission&vision"
                />
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Footer />
    </div>
  );
};
